module.exports = __webpack_public_path__ + "img/fruit2.45e6e6d6.jpg";